class ComparisonTable extends HTMLElement {
    constructor() {
        super();
        this.onTabChange = this.onTabChange.bind(this);
        this.isAnimating = false;
        this.pendingValue = null;
    }

    connectedCallback() {
        this.addEventListener('ui:tabchange', this.onTabChange);
    }

    onTabChange(event) {
        const value = event.detail?.value;
        if (!value) return;

        if (this.isAnimating) {
            this.pendingValue = value;
            return;
        }

        const articles = Array.from(this.querySelectorAll('[data-articletype], [data-article-type]'));
        const values = Array.from(this.querySelectorAll('[data-values-type]'));

        const getArticleType = (el) => el.dataset.articletype || el.dataset.articleType;

        const toShowArticles = articles.filter((el) => getArticleType(el) === value);
        const toHideArticles = articles.filter((el) => getArticleType(el) !== value && !el.hidden);

        const toShowValues = values.filter((el) => el.dataset.valuesType === value);
        const toHideValues = values.filter((el) => el.dataset.valuesType !== value && !el.hidden);

        this.isAnimating = true;

        const hideTl = gsap.timeline({
            onComplete: () => {
                [...toHideArticles, ...toHideValues].forEach((el) => {
                    el.hidden = true;
                    gsap.set(el, { clearProps: 'all' });
                });

                [...toShowArticles, ...toShowValues].forEach((el) => {
                    el.hidden = false;
                });

                const showTl = gsap.timeline({
                    onComplete: () => {
                        this.isAnimating = false;

                        // Als er tijdens animatie een nieuwe waarde is gekozen
                        if (this.pendingValue && this.pendingValue !== value) {
                            const next = this.pendingValue;
                            this.pendingValue = null;
                            this.onTabChange({ detail: { value: next } });
                        } else {
                            this.pendingValue = null;
                        }
                    },
                });

                showTl
                    .fromTo(
                        toShowArticles,
                        { autoAlpha: 0, y: 16 },
                        {
                            autoAlpha: 1,
                            y: 0,
                            duration: 0.4,
                            ease: 'power2.out',
                            stagger: 0.06,
                            clearProps: 'all',
                        },
                        0
                    )
                    .fromTo(
                        toShowValues,
                        { autoAlpha: 0, y: 16 },
                        {
                            autoAlpha: 1,
                            y: 0,
                            duration: 0.4,
                            ease: 'power2.out',
                            stagger: 0.06,
                            clearProps: 'all',
                        },
                        0
                    );
            },
        });

        if (toHideArticles.length || toHideValues.length) {
            hideTl
                .to(
                    toHideArticles,
                    {
                        autoAlpha: 0,
                        y: -12,
                        duration: 0.3,
                        ease: 'power2.in',
                        stagger: 0.05,
                    },
                    0
                )
                .to(
                    toHideValues,
                    {
                        autoAlpha: 0,
                        y: -12,
                        duration: 0.3,
                        ease: 'power2.in',
                        stagger: 0.05,
                    },
                    0
                );
        } else {
            hideTl.progress(1);
        }
    }
}

customElements.define('comparison-table', ComparisonTable);